import { NotificationData } from '@/Support/Communications/Interfaces/NotificationData'
import { RequestPayload, router, VisitOptions } from '@inertiajs/vue3'

export class Notification {
  data: NotificationData

  constructor(data: NotificationData) {
    this.data = data
  }

  get id() {
    return this.data.id
  }

  get title() {
    return this.data.title
  }

  get content() {
    return this.data.content
  }

  get date() {
    return this.data.date
  }

  get owner() {
    return this.data.owner
  }

  get url() {
    return this.data.url
  }

  get urlLabelButton() {
    return this.data.url_label_button
  }

  get unread() {
    return this.data.unread
  }

  get category() {
    return this.data.category
  }

  get system() {
    return this.data.system
  }

  get confirmation() {
    return this.data.confirmation
  }

  get urlWithId(): string | undefined {
    if (this.url) {
      const url = new URL(this.url)
      url.searchParams.append('read_notification_id', this.id)

      return url.toString()
    }
    return this.url
  }

  async visitUrl(
    data?: RequestPayload,
    options?: Exclude<VisitOptions, 'method' | 'data'>,
  ) {
    if (this.urlWithId) {
      const _options = {
        preserveScroll: true,
        preserveState: false,
        ...options,
      }
      router.get(this.urlWithId, data, _options)
    }
  }
}
